import { Textarea, VStack } from '@chakra-ui/react';
import ErrorsContainer from '@components/common/form/ErrorsContainer';
import { useIntl } from 'react-intl';

type Props = {
  sensorText: string;
  setSensorText: (value: string) => void;
  isErrorParsing: boolean;
  setIsErrorParsing: (value: boolean) => void;
};

export default function SensorExpertForm({
  sensorText,
  setSensorText,
  isErrorParsing,
  setIsErrorParsing,
}: Readonly<Props>) {
  const { formatMessage } = useIntl();
  const error = isErrorParsing ? formatMessage({ id: 'error.common.json_parsing_error' }) : null;

  const onChangeSensorJson = (value: string) => {
    setIsErrorParsing(false);
    try {
      JSON.parse(value);
    } catch (e) {
      console.error(e);
      setIsErrorParsing(true);
    } finally {
      setSensorText(value);
    }
  };

  return (
    <VStack height="100%" width="100%" backgroundColor="neutral.700" flex={1} paddingX="180px" paddingY={5} gap={2}>
      <Textarea
        width="100%"
        spellCheck="false"
        flex={1}
        border="2px solid"
        value={sensorText}
        fontSize="14px"
        borderColor="neutral.black"
        backgroundColor="neutral.800"
        resize="none"
        className="cockpit-scrollbar-900"
        onChange={(event) => {
          onChangeSensorJson(event.target.value);
        }}
      />
      {error && <ErrorsContainer apiError={error} />}
    </VStack>
  );
}
